import React from "react";
import { RealEstateData } from "../../Components/services/real-estate/RealEstateData";
import CompareSlider from "../../Components/home/CompareSlider";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";
import Faqs from "../../Components/services/real-estate/Faq";
import before1 from "../../images/services/Before 1.webp";
import after1 from "../../images/services/After 1.webp";
import before2 from "../../images/services/Before 2.webp";
import after2 from "../../images/services/After 2.webp";
import before8 from "../../images/services/Befor 8.webp";
import after8 from "../../images/services/After 8.webp";
import before13 from "../../images/services/Befor 13.webp";
import after13 from "../../images/services/After 13.webp";

const RealEstate = () => {
  const imagePairs = [
    {
      firstImage: before2,
      secondImage: after2,
    },
    {
      firstImage: before8,
      secondImage: after8,
    },
    {
      firstImage: before13,
      secondImage: after13,
    },
    {
      firstImage: before1,
      secondImage: after1,
    },
  ];
  const maxItems = Math.min(RealEstateData.length, imagePairs.length);
  return (
    <>
      <Navbar />
      <div
        className="bg_maincolor d-flex align-items-center justify-content-center"
        style={{ height: "14rem" }}
      >
        <h1 className="container display-6 prata-regular fw-bold text-center text-light ">
          Real Estate Image Services
        </h1>
      </div>
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {Array.from({ length: maxItems }).map((_, index) => (
            <div
              key={index}
              className={`row align-items-center py-5 ${
                index % 2 !== 0 ? "flex-row-reverse " : ""
              }`}
            >
              <div
                className={`col-md-6 my-4  ${index % 2 !== 0 ? "ps-5 " : ""}`}
              >
                <h3 className="prata-regular mb-3">
                  {RealEstateData[index].title}
                </h3>
                <p>
                  {
                    RealEstateData[index].desc.split(
                      "https://captureedits.com/"
                    )[0]
                  }
                  <a
                    href="https://captureedits.com/"
                    className="text_maincolor fw-bold text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    captureedits.com
                  </a>
                  {
                    RealEstateData[index].desc.split(
                      "https://captureedits.com/"
                    )[1]
                  }
                </p>

                <p className="fw-600">{RealEstateData[index].heading}</p>
                <ul>
                  {RealEstateData[index].para1 && (
                    <li>{RealEstateData[index].para1}</li>
                  )}
                  {RealEstateData[index].para2 && (
                    <li>{RealEstateData[index].para2}</li>
                  )}
                  {RealEstateData[index].para3 && (
                    <li>{RealEstateData[index].para3}</li>
                  )}
                  {RealEstateData[index].para4 && (
                    <li>{RealEstateData[index].para4}</li>
                  )}
                  {RealEstateData[index].para5 && (
                    <li>{RealEstateData[index].para5}</li>
                  )}
                  {RealEstateData[index].para6 && (
                    <li>{RealEstateData[index].para6}</li>
                  )}
                  {RealEstateData[index].para7 && (
                    <li>{RealEstateData[index].para7}</li>
                  )}
                </ul>
              </div>
              <div className="col-md-6 my-4">
                <CompareSlider
                  firstImage={imagePairs[index].firstImage}
                  secondImage={imagePairs[index].secondImage}
                  initialSliderPercentage={50}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-center mb-5">
          <Link
            to={"/realestate-order"}
            className="btn bg_maincolor text-white"
          >
            Order Now
          </Link>
        </div>
      </div>
      <Faqs />
      <Footer />
    </>
  );
};

export default RealEstate;
